module.exports = __webpack_public_path__ + "img/轮播2.e532c40d.png";